/**
 * Configuration file for models
 *
 * This file is where you define overrides for the default model behaviors.
 * Settings here apply to all models, and some are inherited by collections.
 */

module.exports = {

  /**
   * The default API connection that models should use if they have no explicit mapping.
   */

  // defaultConnection: 'default'

  /**
   * If your application interacts with multiple APIs, create a connection for each
   * API and then define which models are associated with each connection here.
   *
   * Here is an example for an application with a versioned API (v1 and v2):
   *
   * {
   *   v1: [
   *     'currentUser',
   *     'author'
   *   ],
   *   v2: [
   *     'book',
   *     'publisher'
   *   ]
   * }
   */

  // connectionModelMap: {
  //   default: []
  // }

};



// WEBPACK FOOTER //
// ./config/models.js